/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Search_Shortcut_OtherInputs */

const en_us2_shell_search_shortcut_other = /** @type {(inputs: Shell_Search_Shortcut_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ctrl K`)
};

const pt_br2_shell_search_shortcut_other = /** @type {(inputs: Shell_Search_Shortcut_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ctrl K`)
};

const es_419_shell_search_shortcut_other = /** @type {(inputs: Shell_Search_Shortcut_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ctrl K`)
};

const pt_pt2_shell_search_shortcut_other = /** @type {(inputs: Shell_Search_Shortcut_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ctrl K`)
};

const fr_fr2_shell_search_shortcut_other = /** @type {(inputs: Shell_Search_Shortcut_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ctrl K`)
};

const de_de2_shell_search_shortcut_other = /** @type {(inputs: Shell_Search_Shortcut_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strg K`)
};

const it_it2_shell_search_shortcut_other = /** @type {(inputs: Shell_Search_Shortcut_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ctrl K`)
};

/**
* | output |
* | --- |
* | "Ctrl K" |
*
* @param {Shell_Search_Shortcut_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_search_shortcut_other = /** @type {((inputs?: Shell_Search_Shortcut_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Search_Shortcut_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_search_shortcut_other(inputs)
	if (locale === "es-419") return es_419_shell_search_shortcut_other(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_search_shortcut_other(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_search_shortcut_other(inputs)
	if (locale === "de-DE") return de_de2_shell_search_shortcut_other(inputs)
	if (locale === "it-IT") return it_it2_shell_search_shortcut_other(inputs)
	return en_us2_shell_search_shortcut_other(inputs)
});
export { shell_search_shortcut_other as "shell.search_shortcut_other" }